export default __webpack_public_path__ + "static/media/Frigotech.787db606.jpeg";